const HisAvatar = ({color, sx}) => {
  let _sx = sx ?? {};
  return (
    <svg style={_sx} width="24" height="24" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="white"/>
      <path
        d="M27 28V26C27 24.9391 26.5786 23.9217 25.8284 23.1716C25.0783 22.4214 24.0609 22 23 22H17C15.9391 22 14.9217 22.4214 14.1716 23.1716C13.4214 23.9217 13 24.9391 13 26V28"
        stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path
        d="M20 18C22.2091 18 24 16.2091 24 14C24 11.7909 22.2091 10 20 10C17.7909 10 16 11.7909 16 14C16 16.2091 17.7909 18 20 18Z"
        stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default HisAvatar;